<div class="overlay" *ngIf="isLoading | async">
  <div class="spinner">
    <div class="spinner-part spinner-part1"></div>
    <div class="spinner-part spinner-part2"></div>
    <img src="/assets/images/motorbike.png" alt="Suzuki Bike"
      class="spinner-center">
  </div>
</div>

<div class="container-fluid pl-0 h-100">
  <div class="container-inner">
    <div *ngIf="!isCreate && !isEdit">
      <div class="header-container">
        <h2>Like Hood Master</h2>
          <div class="search-container">
          <input
            type="text"
            [formControl]="searchInput"
            placeholder="Search..."
            (input)="applyFilter()"
            class="form-control"
          />
          <span class="clear-icon" *ngIf="searchInput.value" (click)="clearSearch()">&times;</span>
        </div>
        <div class="button-container">
          <button mat-raised-button class="add-button"
            (click)="isCreate = true"> Add LikeHood Master</button>
        </div>
      </div>
      <div class="leads-table mb-3">
        <table mat-table [dataSource]="dataSource" matSort class="mat-table">
          <ng-container matColumnDef="SNo">
            <th mat-header-cell *matHeaderCellDef> S.No </th>
            <td mat-cell *matCellDef="let element; let i = index">{{i + 1}}</td>
          </ng-container>
          <ng-container matColumnDef="interest">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Interest</th>
            <td mat-cell *matCellDef="let element">{{element.interest}}</td>
          </ng-container>

          <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Created
              At</th>
            <td mat-cell *matCellDef="let element">{{element.createdAt |
              date:'dd/MM/yyyy'}}</td>
          </ng-container>
          <ng-container matColumnDef="updatedAt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Updated
              At</th>
            <td mat-cell *matCellDef="let element">{{element.updatedAt |
              date:'dd/MM/yyyy'}}</td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let element"
              [ngClass]="element.status == 1 ? 'status_active' : 'status_inactive'">
              {{element.status ? 'Active' : 'In-Active'}}</td>
          </ng-container>
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef
              style="text-align: center;">Action</th>
            <td mat-cell *matCellDef="let element" style="text-align: center;">
              <img [src]="bucketurl + '/images/pen.png'" class="edit-pen"
                title="Edit" (click)="edit(element)">
            </td>
          </ng-container>
          <tr mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" style="text-align: center; padding: 20px 0;"
              colspan="8">No data found!</td>
          </tr>
        </table>
      </div>
    </div>

    <div *ngIf="isCreate || isEdit">
      <div class="header-container">
        <h2>{{ isEdit ? 'Edit' : 'Add' }} Like Hood Purchase Master</h2>
        <div class="button-container">
          <button mat-raised-button class="add-button" (click)="back()">Back to
            List</button>
        </div>
      </div>
      <form [formGroup]="likHoodMaster" (ngSubmit)="onSubmit()">
        <div class="row">
  
          <div class="col-12 col-sm-6 col-md-4 mt-2">
            <div class="themeinput">
              <label>Interest</label><span
                style="color: red; font-size: 15px;">&nbsp;*</span>
              <input type="text" class="form-control"
                formControlName="interest">
              <div *ngIf="submitted && f['interest'].errors"
                class="invalid-feedback">
                <div *ngIf="f['interest'].errors['required']">interest
                  is required</div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 mt-2">
            <div class="themeinput">
              <label>Status</label><span
                style="color: red; font-size: 15px;">&nbsp;*</span>
              <select class="form-select" formControlName="status">
                <option value disabled selected>Select Status</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
              <div *ngIf="submitted && f['status'].errors"
                class="invalid-feedback">
                <div *ngIf="f['status'].errors['required']">Status is
                  required</div>
              </div>
            </div>
          </div>
          <div
            class="col-12 col-sm-6 col-md-4 mt-2 d-flex align-items-end gap-3">
            <button type="submit" mat-raised-button class="create-button">{{
              isEdit ? 'Update' : 'Create' }}</button>
            <button type="button" mat-raised-button class="clear-button"
              (click)="clearForm()">Clear</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
